import { ref } from "vue";
import { defineStore } from "pinia";

import {
  getGameSettings,
  updateGameSettings
} from "@/api/settingsApi.js";
import { gameRuntimeBridge } from "@/game/bridge/runtimeBridge.js";
import {
  DEFAULT_GAME_SETTINGS
} from "@/game/runtime/systems/settingsService.js";


export const useSettingsStore = defineStore("settings", () => {
  const settings = ref({
    ...DEFAULT_GAME_SETTINGS
  });

  const loading = ref(false);
  const saving = ref(false);
  const loadError = ref(null);
  const saveError = ref(null);


  async function applySettings(nextSettings) {
    settings.value = {
      ...DEFAULT_GAME_SETTINGS,
      ...nextSettings
    };

    await gameRuntimeBridge.setSettings(settings.value);

    return settings.value;
  }


  async function refresh() {
    loading.value = true;
    loadError.value = null;

    try {
      const remoteSettings = await getGameSettings();

      return await applySettings(remoteSettings);
    } catch (error) {
      loadError.value = error;
      throw error;
    } finally {
      loading.value = false;
    }
  }


  async function update(patch) {
    saving.value = true;
    saveError.value = null;

    try {
      const remoteSettings = await updateGameSettings(patch);

      return await applySettings(remoteSettings);
    } catch (error) {
      saveError.value = error;
      throw error;
    } finally {
      saving.value = false;
    }
  }


  return {
    settings,
    loading,
    saving,
    loadError,
    saveError,
    refresh,
    update
  };
});
